import { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useAppSelector } from "../../app/hooks";
import { Loader } from "./Loader";
import { BasicProps } from "./ComponentsInterface";
import styles from "./VideoPlayer.module.css";

const VideoPlayer = ({ url, children, onLoadError, onEnd, onProgress, onDuration }: VideoPlayerProps): JSX.Element => {
    const disableVideos = useAppSelector((x) => x.globalSettings.disableVideos);
    const [showInitialLoading, setShowInitialLoading] = useState(true);

    const urlOverride = !disableVideos ? url : url + "xxx";

    const autoplay = true;

    useEffect(() => {
        setShowInitialLoading(true);
    }, [urlOverride]);

    const isPlaybackBlockedError = (err: any): boolean => {
        const message = `${err?.message ?? err ?? ""}`.toLowerCase();

        return (
            message.includes("xx8pdd") ||
            message.includes("notallowederror") ||
            message.includes("play()") ||
            message.includes("autoplay") ||
            message.includes("user didn't interact")
        );
    };

    return (
        <div className={`${styles.container} m-auto is-flex is-justify-content-center`}>
            <div className={styles.videoContainer}>
                {children}
                {showInitialLoading && (
                    <div className={styles.loadingOverlay}>
                        <Loader />
                    </div>
                )}
                <ReactPlayer
                    url={urlOverride}
                    width={"100%"}
                    height={"100%"}
                    onPlay={() => setShowInitialLoading(false)}
                    onProgress={(progress) => {
                        if (progress.playedSeconds > 0 || progress.loadedSeconds > 0) {
                            setShowInitialLoading(false);
                        }

                        onProgress?.(progress);
                    }}
                    onDuration={onDuration}
                    onError={(err) => {
                        setShowInitialLoading(false);
                        if (isPlaybackBlockedError(err)) return;
                        onLoadError?.();
                    }}
                    onEnded={onEnd}
                    controls={true}
                    playing={autoplay}
                    config={{
                        vimeo: {
                            playerOptions: {
                                texttrack: "en",
                                controls: true, // we shold disable this on a prod environment
                                responsive: true,
                                keyboard: false,
                                autoplay
                            }
                        }
                    }}
                />
            </div>
        </div>
    );
};

export default VideoPlayer;

interface VideoPlayerProps extends BasicProps {
    url: string;
    onLoadError?: () => void;
    onEnd?: () => void;
    onDuration?: (videoLength: number) => void;
    onProgress?: (progress: any) => void;
}
